export { default as NewsPage } from './NewsPage';
export { default as NewsImageSection } from './NewsImageSection';
export { default as NewsContentSection } from './NewsContentSection';
export { default as NewsSocialMediaSection } from './NewsSocialMediaSection';
export { default as NewsRelatedPostsSection } from './NewsRelatedPostsSection';
export { default as NewsPageWrapper } from './NewsPageWrapper';
